'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { LlmBlock, LlmChunkUnknownItem } from '../../../types';

export const NotFound: React.FC<LlmBlock<LlmChunkUnknownItem>> = (props) => {
  const { item } = props;
  const classNames = getClassNames('llm__not-found', { [`llm__not-found--${item.type}`]: !!item.type });
  return (
    <pre className={classNames}>{JSON.stringify(item, null, 2)}</pre>
  );
};
